import { useParams } from "react-router-dom";
import { RollupDashboard } from "../../components/RollupDashboard";

export function StateDashboard() {
  const { id } = useParams();
  return (
    <RollupDashboard
      scopeType="state"
      scopeId={Number(id)}
      title={`State #${id}`}
      subtitle="All districts + godowns in this state."
    />
  );
}
